import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from "@material-ui/icons/Close";
// import Icon from '@material-ui/core/Icon';
// import HelpIcon from '@material-ui/icons/HelpOutline';
import TButton from "../Buttons/TButton";

class TDrawerHeader extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        title: PropTypes.string,
        expanded: PropTypes.bool,
        showSaveBtnBool: PropTypes.bool,
        onClose: PropTypes.func,
        onSave: PropTypes.func,
        onHelp: PropTypes.func,
        onMinimize: PropTypes.func,
        onMaximize: PropTypes.func,
        saveBtnCaption: PropTypes.string,
    };

    static defaultProps = {
        title: "CUSTOM TITLE GOES HERE",
        expanded: false,
        showSaveBtnBool: true,
        onClose: () => console.log("onClose"),
        onSave: () => console.log("onSave"),
        onHelp: () => console.log("onSave"),
        onMinimize: () => console.log("onMinimize"),
        onMaximize: () => console.log("onMaximize"),
        saveBtnCaption: "Save",
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onCloseBtnClick = () => {
        this.props.onClose();
    };

    onSaveBtnClick = () => {
        this.props.onSave();
    };

    onHelpBtnClick = () => {
        this.props.onHelp();
    };

    onMinimizeBtnClick = () => {
        this.props.onMinimize();
    };

    onMaximizeBtnClick = () => {
        this.props.onMaximize();
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        const styles = {
            formHeader: {
                padding: "10px",
                borderBottom: "1px solid #CCCCCC",
                height: "45px",
            },
            headerTitle: {
                marginLeft: "10",
                display: "inline-block",
                verticalAlign: "top",
                // marginTop: '15px',
                position: "absolute",
                left: 65, //60,
                top: 20,
            },
            headerSubTitle: {
                position: "absolute",
                left: 95, //60,
                top: 39,
                fontSize: 10,
                color: "#757575",
            },
            icons: {
                float: "right",
            },
            saveBtn: {
                padding: 0,
            },
            saveBtnDiv: {
                marginTop: 4,
            },
            helpBtn: {
                // right: '235px'
                // right: '130px'
            },
            minmaxBtn: {
                // right: '185px'
                // right: '135px'
                // right: '80px'
            },
            closeBtn: {
                // verticalAlign: 'top',
                // right: '30px'
            },
        };

        let saveBtn = null;

        if (this.props.showSaveBtnBool) {
            saveBtn = (
                <TButton
                    onClick={this.onSaveBtnClick}
                    containerStyle={{ ...styles.icons, ...styles.saveBtnDiv }}
                    style={{ ...styles.saveBtn }}
                    caption={this.props.saveBtnCaption}
                />
            );
        }

        return (
            <div
                className="DrawerHeader"
                style={styles.formHeader}
            >
                <IconButton
                    onClick={this.onCloseBtnClick}
                    style={{ ...styles.closeBtnDiv }}
                >
                    <CloseIcon />
                </IconButton>

                <h2 style={styles.headerTitle}>{this.props.title}</h2>

                {/*{*/}
                {/*(this.props.expanded) ?*/}
                {/*<IconButton onClick={this.onMinimizeBtnClick} style={{...styles.icons, ...styles.minmaxBtn}}>*/}
                {/*<Icon className='fa fa-window-minimize'/>*/}
                {/*</IconButton>*/}
                {/*:*/}
                {/*<IconButton onClick={this.onMaximizeBtnClick} style={{...styles.icons, ...styles.minmaxBtn}}>*/}
                {/*<Icon className='fa fa-window-maximize'/>*/}
                {/*</IconButton>*/}
                {/*}*/}

                {/*<IconButton onClick={this.onHelpBtnClick} style={{...styles.icons, ...styles.helpBtn}}>*/}
                {/*<HelpIcon />*/}
                {/*</IconButton>*/}

                {saveBtn}
            </div>
        );
    }
}

export default TDrawerHeader;
